import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDnph7mqomHzOON_oA0iQL6HO1axAxrli8",
  authDomain: "geo-diet-wonder.firebaseapp.com",
  databaseURL: "https://geo-diet-wonder-default-rtdb.firebaseio.com",
  projectId: "geo-diet-wonder",
  storageBucket: "geo-diet-wonder.firebasestorage.app",
  messagingSenderId: "308834769692",
  appId: "1:308834769692:web:4cb4deecd92674ed06f8d9",
  measurementId: "G-DCM4ZJKTBS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
// Initialize Firebase Storage with specific bucket
const storage = getStorage(app);

console.log("Firebase Storage initialized with bucket:", firebaseConfig.storageBucket);

export { auth, db, storage };